import IPickListItem from "../commons/IPickListItem";
import moment from "moment";

export class SolicitacaoModel extends IPickListItem {
  idServico: number;
  numeroServico: string;
  data: Date;
  descricaoServico: string;
  status: string;
  valor: number;
  statusServico: string;

  idPrestador: number;
  nomePrestador: string;
  nomeCliente: string;
  cpfCnpjPrestador: string;

  aceitaReenvioSolicitacao: boolean;
  preco?: number;

  constructor(
    idServico: number,
    numeroServico: string,
    data: Date,
    descricaoServico: string,
    status: string,    
    valor: number,
    statusServico: string,

    idPrestador: number,
    nomePrestador: string,
    nomeCliente: string,
    cpfCnpjPrestador: string,
    aceitaReenvioSolicitacao: boolean,
    preco?: number,
  ) {
    super();
    this.idServico = idServico;
    this.numeroServico = numeroServico;
    this.data = data;
    this.descricaoServico = descricaoServico;
    this.status = status;
    this.valor = valor;
    this.statusServico = statusServico;

    this.idPrestador = idPrestador;
    this.nomePrestador = nomePrestador;
    this.nomeCliente = nomeCliente;
    this.cpfCnpjPrestador = cpfCnpjPrestador;
    this.aceitaReenvioSolicitacao = aceitaReenvioSolicitacao;
    this.preco =  preco;
  }

  get descricao(): string {
    return `${this.idServico} - ${moment(this.data).format("DD/MM/YYYY")} - ${
      this.descricaoServico
    } -  ${this.valor}`;
  }

  get key(): string {
    return `${this.idServico}`;
  }

  get prestador(): string {
    if (this.idPrestador == null) {
      return `Sem Prestador`;  
    }
    return `${this.cpfCnpjPrestador} - ${this.nomePrestador}`;
  }
  
}
